var map = {
	"./en.json": [
		1094,
		149
	],
	"./zh-cn.json": [
		1095,
		150
	],
	"./zh-hk.json": [
		1096,
		151
	],
	"./zh-tw.json": [
		1097,
		152
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 1020;
module.exports = webpackAsyncContext;